export enum PlayerHandActions {
  FOLD = "FOLD",
  CALL = "CALL",
  RAISE = "RAISE",
  ALL_IN = "ALL_IN",
  CHECK = "CHECK",
  BET = "BET",
}

